import $ from 'jquery'
import {Core} from "../../../assets/src/scripts/core.js";

export class TableOffer {

  constructor($container) {
    if (Core.isAdmin()) return

    this.$window = $(window)
    this.$document = $(document)
    this.$container = $container

    this.classes = {
      active: 'active',
      tableBody: 'table-offer-body',
      cell: 'cell',
      focusLine: 'focus-line'
    }
    this.$menu = this.$container.find('.table-offer-menu')
    this.$menuContainer = this.$container.find('.table-offer-menu-container')
    this.$content = this.$container.find('.table-offer-content')
    this.$header = this.$container.find('.table-offer-header')
    this.$headerContainer = this.$container.find('.table-offer-header-container')
    this.$body = this.$container.find(`.${this.classes.tableBody}`)
    this.$cells = this.$container.find('.cell')
    this.$choices = this.$container.find('.table-offer-dual-price-content')

    this.indexSlideActive = 0

    this.$document.ready(this.handleReady.bind(this))
    this.$window.on('resize', this.refresh.bind(this))
    this.$menu.find('> div').on('click', this.handleClickMenu.bind(this))
    this.$choices.on('click', 'button', this.handleClickButton.bind(this))
    this.$header.on('sticky:top', this.refresh.bind(this))
  }

  refresh() {
    this.$content.find('.cell[style]').removeAttr('style')
    this.fixCellHeight()
    this.fixHeightHeader()
    this.fixBgCellHeight()
    this.fixHeightMenuMobile()

    if (Core.isBpGreaterThan('xl')) return

    this.slideToCol(this.indexSlideActive)
  }

  handleReady(e) {
    setTimeout(this.fixHeightHeader.bind(this), 500)
    setTimeout(this.fixHeightMenuMobile.bind(this), 500)
    setTimeout(this.fixCellHeight.bind(this), 500)
    setTimeout(this.fixBgCellHeight.bind(this), 500)
  }

  handleClickMenu(e) {
    e.preventDefault()
    this.slideToCol($(e.currentTarget).index())
  }

  fixHeightHeader() {
    this.$headerContainer.css('height', this.$header.height())
  }

  fixHeightMenuMobile() {
    this.$menuContainer.css('height', this.$menu.height())
  }

  fixBgCellHeight() {
    let self = this
    let $col = this.$container.find(`.${this.classes.tableBody} > div`)

    $col.each((colIndex, col) => {
      let heightBgCell = 0
      let $currentBgCell = null
      let $cells = $(col).find(`.${self.classes.cell}`)
      let nbrCells = $(col).find(`.${self.classes.cell}`).length

      $cells.each((cellIndex, cell) => {
        let $cell = $(cell)
        let isLastCell = cellIndex === nbrCells - 1

        if ($currentBgCell === null) {
          $currentBgCell = $cell
        }

        if ($cell.hasClass(self.classes.focusLine) || isLastCell) {
          if (isLastCell) {
            heightBgCell += $cell.outerHeight(true)
          }

          if ($currentBgCell && heightBgCell > 0) {
            $currentBgCell.css('--height-before', heightBgCell + "px");
          }

          $currentBgCell = null
          heightBgCell = 0
          return
        }

        heightBgCell += $cell.outerHeight(true)
      })
    })
  }

  /**
   * Permet d'obtenir la même hauteur pour toutes les cellules d'une même ligne
   */
  fixCellHeight() {
    let $header = this.$container.find('.table-offer-header > div')
    let heightCell = 32
    $header.each((colIndex, cell) => {
      let heightCurrentCell = $(cell).innerHeight()

      if (colIndex === 0) {
        heightCell = 0
      } else if (heightCell < heightCurrentCell) {
        heightCell = heightCurrentCell
      }
    })
    $header.each((cellIndex, cell) => {
      $(cell).css('height', heightCell + "px");
    })
    this.$container.find('.cell-image img').css({
      height: '100%'
    })

    let $bodyCol = this.$container.find('.table-offer-body > div')
    let heightCells = []
    $bodyCol.each((colIndex, col) => {
      $(col).find('.cell').each((cellIndex, cell) => {
        let heightCell = $(cell).innerHeight()

        if (colIndex === 0 || parseInt(heightCells[cellIndex]) < heightCell) {
          heightCells[cellIndex] = heightCell
        }
      })
    })
    $bodyCol.each((colIndex, col) => {
      $(col).find('.cell').each((cellIndex, cell) => {
        $(cell).css('height', heightCells[cellIndex] + "px");
      })
    })
  }

  slideToCol(indexCol) {
    this.indexSlideActive = indexCol
    let leftPositionMenu = this.$content.offset().left

    // Menu
    let $itemActive = this.$menu.find('> div').eq(indexCol)
    this.$menu.find('.active').removeClass('active')
    $itemActive.addClass('active')
    this.$menu.animate({
      scrollLeft: `+=${$itemActive.offset().left - leftPositionMenu}px`
    }, 150);

    // Body
    let leftPositionCol = 0
    for (let i = 1; i <= indexCol; i++) {
      leftPositionCol += this.$body.find('> div').eq(i).outerWidth(true)
    }
    // if (indexCol > 0) leftPositionCol += 32
    this.$content.find('> div').css('transform', `translateX(-${leftPositionCol}px)`)
  }

  handleClickButton(e) {
    e.preventDefault()
    let $button = $(e.currentTarget)
    let target = $button.data('id')

    this.$container.find(`.${this.classes.active}`).removeClass(this.classes.active)

    $button.addClass(this.classes.active)
    this.$container.find(`.${target}`).addClass(this.classes.active)
  }
}
